import React, { useEffect, useState } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import InputControl from '../InputControl'
import Swal from 'sweetalert2'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import requestApi from '../../utils/request';
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { faqmanagement } from '../../config/routingConsts';
import { ReactComponent as IconClose } from '../../assets/images/icons/icon-modal-close.svg'


//#region  form Validation 
const validationSchema = yup.object({
  question: yup.string().required("Please enter question"),
  answer: yup.string().required("Please enter answer"),
      });
      //#endregion

const FAQAddEditModal = ({openModal,setOpenModal,updateId,setUpdateId}) => {

  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const {state} =useLocation()

  //#region react-hook-form
const {
  register,
  control,
  handleSubmit,
  reset,
  getValues,
  setValue,
  watch,
  setError,
  formState: { errors, submitCount },
} = useForm({
  mode: "all",
  resolver: yupResolver(validationSchema),
});
//#endregion

   //#region View FAQ-by-Id
  async function viewFAQ(faqId) {
      return await requestApi
          .post(
              `/faq/view`,
              { faqId: faqId },
              { headers: true }
          )
          .then((res) => {
              return res.data
          })
  }
  
  const { data, isLoading } = useQuery({
      queryKey: ['view-faq'],
      queryFn: () => viewFAQ(updateId),
      enabled: !!updateId,
      onSuccess: (data) => {
          reset({
              question:data?.data?.question,
              answer:data?.data?.answer
          }) 
      }
  })

  //#endregion View FAQ by Id

  //#region add/edit FAQ
async function newaddFaq(payload) {
  if (updateId) {
      return await requestApi
          .post(
              `faq/add-edit`,
             {faqId:updateId,...payload} 
          )
          .then((res) => {
              return res.data
          })
  } else {
      return await requestApi
          .post(
              `faq/add-edit`,
              payload
          )
          .then((res) => {
              return res.data
          })
  }
}

const mutation = useMutation(newaddFaq, {
  onSuccess: (data) => {
      Swal.fire({
          position: 'center',
          icon: 'success',
          title: '',
          allowOutsideClick: false,
          text: data?.meta?.message
      }).then(() => {
        setValue("answer"," ")
        setValue("question"," ")
        setOpenModal(false)
        navigate(faqmanagement)
        queryClient.invalidateQueries({ queryKey: 'faqlist', page: 1, limit: 10 })
      })
  },
  onError: (error) => {
      Swal.fire({
          position: 'center',
          icon: 'error',
          title: '',
          allowOutsideClick: false,
          text: error?.message
      })
  }
})
//#endregion

  const handleAddEditsize=(data)=>{
       mutation.mutate(data)  
  }

  const handleClose =()=>{
    setValue("answer"," ")
    setValue("question"," ")
    setOpenModal(false)
    queryClient.invalidateQueries({ queryKey: 'faqlist', page: 1, limit: 10 })
  }

  return (
      <>
          <Modal
              centered
              show={openModal}
              onHide={handleClose}
              className="confirm-modal filter-modal"
          >
              <Modal.Body>
                  <div className="head">
                      <h2>{updateId ? "Edit ":"Add "} FAQ</h2>
                      <div className="close">
                          <IconClose
                              onClick={handleClose}
                          />
                      </div>
                  </div>
                  <form onSubmit={handleSubmit(handleAddEditsize)}>
                      <Row>
                          <Col lg="12">
                              <div className="form-group">
                                  <InputControl
                                    //   autoFocus={openModal}
                                      label="Question"
                                      name="question"
                                      register={register}
                                      error={errors?.question?.message}
                                  />
                              </div>
                          </Col>
                          <Col lg="12">
                              <div className="form-group">
                                  <label>Answer</label>
                                  <textarea
                                      id=""
                                      cols="30"
                                      rows="8"
                                      name="answer"
                                      {...register('answer')}
                                  ></textarea>
                                  {errors?.answer?.message && (
                                      <span style={{ color: 'red' }}>
                                          {errors?.answer?.message}
                                      </span>
                                  )}
                              </div>
                          </Col>
                          <Col lg="12">
                              <button type="submit" className="solid-red-btn">
                                  {updateId ?"Edit" :"Add"}
                              </button>
                          </Col>
                      </Row>
                  </form>
              </Modal.Body>
          </Modal>
      </>
  )
}

export default FAQAddEditModal